module.exports = __webpack_public_path__ + "img/sh_ln.6d5b3e8e.svg";